// ===== Packages =====

import {
    getFunctions,
    httpsCallable,
}                               from 'firebase/functions';

const createPost = async ({
    test,
    postId,
    title,
    subtitle,
}: {
    test: boolean,
    postId: string,
    title?: string,
    subtitle?: string,
}): Promise<boolean> => {
    const functions = getFunctions();
    const handleCreatePost = httpsCallable<
        Record<
            string,
            boolean | string | undefined
        >,
        boolean
    >(
        functions,
        'createPost',
    );
    return handleCreatePost({
        test,
        postId,
        title,
        subtitle,
    }).then((result) => {
        const created = result.data as boolean;
        return created;
    }).catch((err) => {
        throw err;
    });
};

export default createPost;
